import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import type { RouteLocationNormalized } from 'vue-router';

import { i18n } from '@/i18n';

const TITLE_DEFAULT = i18n.global.t('app.title');
const TITLE_TEMPLATE_PLACEHOLDER = '%s';
const TITLE_TEMPLATE = `${TITLE_TEMPLATE_PLACEHOLDER} - ${TITLE_DEFAULT}`;

const renderTitle = (title: string): string =>
  TITLE_TEMPLATE.replace(TITLE_TEMPLATE_PLACEHOLDER, title);

export default (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
): true => {
  let title: string | undefined;
  if (isString(to.meta.title)) {
    title = to.meta.title;
  } else if (isFunction(to.meta.title)) {
    title = to.meta.title(to);
  }

  document.title = title ? renderTitle(title) : TITLE_DEFAULT;

  return true;
};
